import { render } from "./NewsletterView.vue?vue&type=template&id=3f65dd5c&scoped=true"
import script from "./NewsletterView.vue?vue&type=script&lang=js"
export * from "./NewsletterView.vue?vue&type=script&lang=js"

import "./NewsletterView.vue?vue&type=style&index=0&id=3f65dd5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f65dd5c"]])

export default __exports__